export default "__VITE_ASSET__BGo_RoKK__"